import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useWindowResize } from '../../hooks/window/useWindowResize';
import { Menu, X } from 'lucide-react';

export default function HeaderBox({
  isLogin,
  scrollToSection,
}: {
  isLogin: boolean;
  scrollToSection: (section: string) => void;
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isMobile } = useWindowResize();

  const handleLogoClick = () => {
    window.location.reload();
    window.scrollTo({ top: 0 });
  };

  const handleMenuClick = (section: string) => {
    scrollToSection(section);
    if (isMobile) {
      setIsMenuOpen(false);
    }
  };

  const menuItems = [
    { label: '협회 소개', section: 'section1' },
    { label: '협회 서비스', section: 'section2' },
    { label: '협회장 인사말', section: 'section3' },
    { label: 'CI 소개', section: 'sectionCI' },
    { label: '그룹사', section: 'section4' },
  ];

  const renderAuthButtons = () =>
    !isLogin ? (
      <>
        <Link
          to='https://kodeal.fks.co.kr/login'
          target='_blank'
          className='text-center min-w-[100px] py-[14px] px-[20px] rounded-[10px] border border-[#E5E5EC] hover:bg-gray-50 transition-colors'
        >
          로그인
        </Link>
        <Link
          to='https://kodeal.fks.co.kr/signup'
          target='_blank'
          className='text-center min-w-[100px] py-[14px] px-[20px] rounded-[10px] bg-[#172A88] text-white hover:bg-[#1B318F] transition-colors'
        >
          회원가입
        </Link>
      </>
    ) : (
      <Link
        to='https://kodeal.fks.co.kr'
        target='_blank'
        className='text-center min-w-[100px] py-[14px] px-[20px] rounded-[10px] border border-[#E5E5EC] hover:bg-gray-50 transition-colors'
      >
        코딜홈 바로가기
      </Link>
    );

  return (
    <header className='w-full fixed left-0 top-0 bg-white z-30'>
      <div className='max-w-[1080px] mx-auto h-[80px] flex justify-between items-center px-4'>
        <div className='flex justify-start items-center gap-[30px] flex-1 md:gap-[10px]'>
          <h1
            className='w-[160px] md:w-[214px] shrink-0 cursor-pointer'
            onClick={handleLogoClick}
          >
            <img
              src='/imgs/icons/logo.webp'
              alt='한국영업경제인협회'
              className='w-full h-[32px] md:h-[42px] object-contain'
            />
          </h1>

          {/* Desktop Navigation */}
          {!isMobile && (
            <nav className='w-full flex-1'>
              <ul className='w-full flex justify-start items-center gap-[7%] max-w-[550px] whitespace-nowrap'>
                {menuItems.map((item) => (
                  <li
                    key={item.section}
                    className='py-[13px] px-[5px] block cursor-pointer text-center hover:text-[#172A88] transition-colors text-balance md:hidden lg:block'
                    onClick={() => handleMenuClick(item.section)}
                  >
                    <p className='text-balance'>{item.label}</p>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </div>

        {/* Desktop Auth Buttons */}
        {!isMobile && (
          <div className='flex justify-start items-center gap-[10px]'>
            {renderAuthButtons()}
          </div>
        )}

        {/* Mobile Menu Button */}
        {isMobile && (
          <button className='p-2' onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        )}
      </div>

      {/* Mobile Menu */}
      {isMobile && isMenuOpen && (
        <div className='fixed inset-0 top-[80px] bg-white z-20'>
          <nav className='p-4'>
            <ul className='flex flex-col gap-4'>
              {menuItems.map((item) => (
                <li
                  key={item.section}
                  className='py-3 px-4 cursor-pointer hover:bg-gray-50 rounded-lg transition-colors'
                  onClick={() => handleMenuClick(item.section)}
                >
                  {item.label}
                </li>
              ))}
            </ul>
            <div className='mt-6 flex flex-col gap-3 p-4'>
              {renderAuthButtons()}
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
